module.exports = __webpack_public_path__ + "img/mzb_logo.80c8668b.png";